import React, { useState } from "react";
import { Container, Carousel, Row, Col } from "react-bootstrap";

const data = [
  {
    id: 1,
    title: "Business & System Discovery",
    description:
      "We look at workflows, user roles, dependencies, and the systems your software needs to support.",
  },
  {
    id: 2,
    title: "MVP Development",
    description:
      "We start with a focused version of the product to validate core functionality and reduce unnecessary complexity early on.",
  },
  {
    id: 3,
    title: "Product Alignment & Refinement",
    description:
      "Based on usage and feedback, the system is refined to better match real workflows and evolving requirements.",
  },
  {
    id: 4,
    title: "Scaling & Optimization",
    description:
      "We enhance performance, security, and scalability to support business growth and future needs.",
  },
];

// Function to group items per slide
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function ApproachCarousel() {
  const [index, setIndex] = useState(0);

  const itemsPerSlide = 3;
  const slides = chunkArray(data, itemsPerSlide);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="padding-section-large approach-section bg-dark text-white">
      <Container>
        {/* Header */}

        <Row className='mb-4 pt-5 align-items-end mb-5'>
          <Col md={10}>
            <h2 className="heading-style-h2 pb-3">How We Approach<span className="text-gradient-1">Custom Software Development </span></h2>
            <h5 className='heading-style-h5'>A structured process that connects business needs, product thinking, and engineering execution.</h5>
          </Col>
          <Col md={2}>
            <div className="carousel-controls pb-3">
              <button className="nav-btn" onClick={() =>
                setIndex((index - 1 + slides.length) % slides.length)
              }>
                ‹
              </button>
              <button className="nav-btn" onClick={() => setIndex((index + 1) % slides.length)}>
                ›
              </button>
            </div>
          </Col>
        </Row>
        {/* Carousel */}
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
        >
          {slides.map((slide, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <Row>
                {slide.map((item) => (
                  <Col md={4} key={item.id} className="mb-4">
                    <div className="approach-card d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="heading-style-h4 text-gradient-1">{item.id}</h4>
                        <h4 className="heading-style-h4 pb-5">{item.title}</h4>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <Row>
          <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto mt-5'>
            <p className='mb-0'>From initial concept to scaling systems, the focus stays on building software that remains reliable as it grows.</p>
          </div>
        </Row>
      </Container>
    </section >
  );
}